import { scroller } from 'react-scroll';
import { scrollPointForAgency, scrollPointForAgent } from '@domain-group/fe-co-allhomes-enquiry-form';
export var scrollTo = scrollPoint => scroller.scrollTo(scrollPoint, {
  duration: 400,
  smooth: true,
  offset: 0
});
export var scrollToEnquiryForm = _ref => {
  var agency = _ref.agency,
    agent = _ref.agent;
  return scrollTo(agency ? scrollPointForAgency(agency) : scrollPointForAgent(agent));
};